import Component from "./ButtonInline";
import Counter from "./components/Counter/ButtonInlineCounter";
import { LeftIcon, RightIcon } from "./components/Icon/ButtonInlineIcon";
import Label from "./components/Label/ButtonInlineLabel";
import Loader from "./components/Loader/ButtonInlineLoader";

interface IButtonInlineExtensions {
    Label: typeof Label;
    LeftIcon: typeof LeftIcon;
    RightIcon: typeof RightIcon;
    Loader: typeof Loader;
    Counter: typeof Counter;
}

export const ButtonInline: typeof Component & IButtonInlineExtensions =
    Object.assign(Component, {
        Label,
        LeftIcon,
        RightIcon,
        Loader,
        Counter,
    });

export type { ButtonInlineProps } from "./types";
